var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPbIconPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "12px",
    viewBox: "0 0 22 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Playbar-Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-192.000000, -1450.000000)",
    id: "assets"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.000000, 1378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pbIconPrev",
    transform: "translate(144.000000, 78.000000) rotate(180.000000) translate(-144.000000, -78.000000) translate(128.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3214286,16.9985029 L14.7337363,21.9620437 C14.5592068,22.0523975 14.3444764,21.9841596 14.2541226,21.8096301 C14.2279471,21.7590688 14.2142857,21.702965 14.2142857,21.64603 L14.2142857,17.4607343 L5.51945061,21.9620437 C5.34492107,22.0523975 5.13019068,21.9841596 5.03983688,21.8096301 C5.01366138,21.7590688 5,21.702965 5,21.64603 L5,10.3558506 C5,10.1593197 5.15931973,10 5.35585057,10 C5.41278589,10 5.46889006,10.0136615 5.51945149,10.0398373 L14.2142857,14.541177 L14.2142857,10.3558506 C14.2142857,10.1593197 14.3736054,10 14.5701363,10 C14.6270716,10 14.6831758,10.0136615 14.7337372,10.0398373 L24.3214286,15.0034117 L24.3214286,11.0191243 C24.3214286,10.724328 24.5604082,10.4853484 24.8552044,10.4853484 L26.4662242,10.4853484 C26.7610204,10.4853484 27,10.724328 27,11.0191243 L27,20.9829401 C27,21.2777364 26.7610204,21.516716 26.4662242,21.516716 L24.8552044,21.516716 C24.5604082,21.516716 24.3214286,21.2777364 24.3214286,20.9829401 L24.3214286,16.9985029 Z",
    id: "Combined-Shape",
    fill: "#858199"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPbIconPrev);
export default __webpack_public_path__ + "static/media/pbIconPrev.a696e0ed.svg";
export { ForwardRef as ReactComponent };